import { Box, MenuItem, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ThemeTokens } from '@acp/core-ui';
import { useNavLink } from '@acp/feature/auth';

export type MobileNavigationItemProps = {
    to?: string;
    label: string;
    isExternal?: boolean;
    onClick?: () => void;
};

export function MobileNavigationItem({
    to,
    label,
    isExternal = false,
    onClick,
}: MobileNavigationItemProps) {
    const href = useNavLink({ to, isExternal });

    return (
        <Box w="full" borderBottomWidth={1} borderBottomColor="muted.50">
            <MenuItem
                as={onClick === undefined ? Link : undefined}
                to={href ?? ''}
                onClick={onClick}
                fontWeight={500}
                p={0}
            >
                <Text
                    px={ThemeTokens.Defaults.px}
                    py={ThemeTokens.Defaults.py}
                >
                    {label}
                </Text>
            </MenuItem>
        </Box>
    );
}
